"use client";

import { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import "./App.css";

import MainSidebar from "./components/main/views/MainSidebar";
import Header from "./components/main/views/Header";
import HomePage from "./components/main/views/Homepage";
import Home from "./components/sorting/views/Home";
import BinaryTreeVisualizer from "./components/trees/views/BinaryTreeVisualizer";
import AVLTreeVisualizer from "./components/trees/views/AVLTreeVisualizer";
import DepthFs from "./components/trees/views/DepthFs";
import BreathFs from "./components/trees/views/BreathFs";
import Rbt from "./components/red-black-tree/views/Rbt";
import Ns from "./components/naive-string/views/Ns";
import Rk from "./components/rabin-karp/views/Rk";
import Bm from "./components/boyer-moore/views/bm";
import NotesPage from "./pages/Notespage";
import Time from "./pages/Time";
import TsApp from "./components/travelling-salesman/views/TsApp";
import LinkedList from "./components/linked-list/views/LinkedList";
import StackQueue from "./components/stack-queue/views/StackQueue";
import Lcs from "./components/lcs/views/Lcs";
import MergeSort3D from "./components/merge-sort-3d/MergeSort3D";
import AboutPage from "./components/main/views/AboutUs";
import Analytics from "./pages/Analytics";
import ProtectedRoute from "./components/shared/ProtectedRoute";
import MySpace from "./pages/MySpace";
import { AuthModalProvider } from "./components/auth/AuthModalContext";
import AuthModal from "./components/auth/AuthModal";
import { WhatsNewProvider } from "./components/announcements/WhatsNewContext";
import WhatsNewModal from "./components/announcements/WhatsNewModal";
import { initGA, trackPage } from "./utils/Ga";

const GA_ENABLED = process.env.NODE_ENV === "production";

const AnalyticsWrapper = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    if (GA_ENABLED) initGA();
  }, []);

  useEffect(() => {
    if (GA_ENABLED) trackPage(location.pathname);
  }, [location]);

  return children;
};

const AppContent = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleSidebarToggle = () => setSidebarOpen(!sidebarOpen);

  return (
    <AuthModalProvider>
    <WhatsNewProvider>
    <div className="App">
      {sidebarOpen && (
        <MainSidebar closeSidebar={() => setSidebarOpen(false)} />
      )}

      <div className={`main-layout ${sidebarOpen ? "sidebar-open" : ""}`}>
        <Header toggleSidebar={handleSidebarToggle} sidebarOpen={sidebarOpen} />

        <main className="main-content">
          <Routes>
            <Route path="/" element={<Navigate to="/homepage" replace />} />

            <Route path="/homepage" element={<HomePage />} />
            <Route path="/visualization/sorting" element={<Home />} />
            <Route path="/visualization/trees/tree-traversal" element={<BinaryTreeVisualizer />} />
            <Route path="/visualization/trees/avl-trees" element={<AVLTreeVisualizer />} />
            <Route path="/visualization/shortest-path/dfs" element={<DepthFs />} />
            <Route path="/visualization/shortest-path/bfs" element={<BreathFs />} />
            <Route path="/visualization/travelling-salesman" element={<TsApp />} />
            <Route path="/visualization/trees/red-black-tree" element={<Rbt />} />
            <Route path="/visualization/string/naive-string" element={<Ns />} />
            <Route path="/visualization/string/rabin-karp" element={<Rk />} />
            <Route path="/visualization/string/boyer-moore" element={<Bm />} />
            <Route path="/visualization/linkedlist" element={<LinkedList />} />
            <Route path="/visualization/stack-queue" element={<StackQueue />} />
            <Route path="/visualization/lcs" element={<Lcs />} />
            <Route
              path="/visualization/3d/merge-sort"
              element={
                <ProtectedRoute>
                  <MergeSort3D />
                </ProtectedRoute>
              }
            />
            <Route path="/notes" element={<NotesPage />} />
            <Route path="/time" element={<Time />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route
              path="/my-space"
              element={
                <ProtectedRoute>
                  <MySpace />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<h2 style={{ color: "white" }}>Page Not Found</h2>} />
          </Routes>
        </main>
      </div>

      <AuthModal />
      <WhatsNewModal />
    </div>
    </WhatsNewProvider>
    </AuthModalProvider>
  );
};

function App() {
  return (
    <Router>
      <AnalyticsWrapper>
        <AppContent />
      </AnalyticsWrapper>
    </Router>
  );
}

export default App;
